import React from 'react';

import AuthCardLayout from 'layouts/AuthCardLayout';

const Logout = () => {
  return (
    <AuthCardLayout>
      <div className="text-center">
      </div>
    </AuthCardLayout>
  );
};

export default Logout;
